import React from "react";
import styled from "styled-components";

function IndustrySectors({vendor}) {
  return (
 <Frame1501>
      <Frame1501_0001>
        <EditProfilePicture>Industry Sectors</EditProfilePicture>

        {vendor?.vendor_industry_sector?.map((item, index) => (
          <Frame1500 key={index}>
            <Sector>{item}</Sector>
          </Frame1500>
        ))}
      </Frame1501_0001>
    </Frame1501>
  );
}

export default IndustrySectors;

const Frame1501 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-end;
  flex: 1;
  gap: 21px;
  width: 100%;
  box-sizing: border-box;
`;

const Frame1501_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  border: solid 1px rgb(225, 228, 233);
  border-radius: 16px;
  align-self: stretch;
  background: rgb(255, 255, 255);
  box-sizing: border-box;
  padding: 16px;
  flex-shrink: 0;
`;

const EditProfilePicture = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: clamp(18px, 3vw, 24px);
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  text-align: left;
`;

const Frame1500 = styled.div`
  display: flex;
  padding-bottom: var(--Padding-Normal, 16px);
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  border-bottom: 1px solid var(--Color-border-dark, rgba(136, 136, 136, 0.1));
`;

const Sector = styled.div`
  color: var(--Color-Text-Text, #212543);

  /* P4 */
  font-family: Montserrat;
  font-size: var(--Fonts-P4, 14px);
  font-style: normal;
  font-weight: 500;
  line-height: 160%; /* 22.4px */
`;
